// eslint-disable-next-line max-len
import feathersClient, { makeServicePlugin, BaseModel, makeServiceStore } from '../../feathers-client';

const servicePath = 'temp-rfqs';

const Model = class TempRfq extends BaseModel {
  static modelName = 'TempRfq';

  static instanceDefaults() {
    return {
      isCsi: false,
      csiRfqId: '',
    };
  }
};

export default {
  plugin: makeServicePlugin({
    servicePath,
    service: feathersClient.service(servicePath),
    Model,
  }),

  store: makeServiceStore({ servicePath, Model }),
};
